<div class="horario-funcionamento">
  <div class="topico-modal-lateral topico-modal-lateral--full" style="position: relative; top: -10px;">
    <span class="label">Horário de Funcionamento</span>
  </div>

  <div class="horario-funcionamento__conteudo">
    @if (!readOnly) {
      @if (podeAdicionarFuncionamento) {
        <app-button-padrao
          width="fit-content"
          height="20px"
          [fontSize]="'12px'"
          [padding]="'2px 10px'"
          [label]="textoBotaoAcao"
          backgroundColor="var(--primary)"
          color="white"
          (buttonClick)="adicionarFuncionamento()"></app-button-padrao>
      }

      @if (modoCadastroAberto) {
        <div class="horario-funcionamento__editor">
          <app-dias-semana
            [diasDisponiveis]="diasDisponiveis"
            [diasSelecionados]="diasSelecionados"
            (diasSelecionadosChange)="diasSelecionados = $event">
          </app-dias-semana>

          <div class="horario-funcionamento__acoes">
            <app-form-field
              #horaInicioInput
              widthFormField="100%"
              heightFormField="35px"
              type="time"
              [value]="horaInicio"
              placeholder="00:00"
              [disabled]="readOnly"
              (changeValue)="atualizarHoraInicio($event)">
            </app-form-field>

            <app-form-field
              #horaFimInput
              widthFormField="100%"
              heightFormField="35px"
              type="time"
              [value]="horaFim"
              placeholder="00:00"
              [disabled]="readOnly"
              [min]="getMinumoHoraFim()"
              (changeValue)="atualizarHoraFim($event)">
            </app-form-field>

            <app-button-padrao
              width="36px"
              height="36px"
              backgroundColor="var(--verde-padrao)"
              color="white"
              icon="check"
              class="cursor-pointer"
              [disabled]="!podeTentarSalvarHorario"
              (buttonClick)="confirmarFuncionamento()"></app-button-padrao>

            <app-button-padrao
              width="36px"
              height="36px"
              backgroundColor="white"
              color="var(--vermelho-padrao)"
              borderColor="var(--vermelho-padrao)"
              borderStyle="solid"
              borderWidth="1px"
              class="cursor-pointer"
              icon="close"
              (buttonClick)="cancelarEdicao()"></app-button-padrao>
          </div>
        </div>
      }
    }

    @if (deveMostrarHorarios) {
      <div class="horario-funcionamento__lista">
        @for (horario of horarios; track trackByHorario($index, horario)) {
          <div class="horario-card">
            <div class="horario-card__dias">
              @for (dia of horario.dias; track dia) {
                <span class="horario-card__dia">{{ obterLabelDia(dia) }}</span>
              }
            </div>

            <div class="horario-card__faixa">
              <span>{{ horario.horaInicio }} - {{ horario.horaFim }}</span>
              @if (!readOnly) {
                <img width="22px"
                  height="22px"
                  class="icones cursor-pointer"
                  src="./assets/icones/edit.svg"
                  alt="Editar horário"
                  tabindex="0"
                  role="button"
                  (click)="editarHorario($index)"
                  (keydown.enter)="editarHorario($index)" />
                <img width="22px"
                  height="22px"
                  class="icones cursor-pointer"
                  src="./assets/icones/delete-forever.svg"
                  alt="Remover horário"
                  tabindex="0"
                  role="button"
                  (click)="deletarHorarios($index)"
                  (keydown.enter)="deletarHorarios($index)" />
              }
            </div>
          </div>
        }
      </div>
    }

    @if (deveMostrarMensagemInatividade) {
      <div class="horario-funcionamento__mensagem">
        <span class="label">Mensagem de Inatividade de Funcionamento</span>
        <textarea
          style="font-size: 12px"
          [value]="mensagemInatividadeFuncionamento"
          (input)="atualizarMensagemInatividadeFuncionamento($any($event.target).value)"
          rows="4"
          [disabled]="readOnly"
        ></textarea>
      </div>
    }
  </div>
</div>
